import { ILetterTemplate } from '../../models/ILetterTemplate';
import { TemplateActions, TemplateActionTypes } from '../action-types/templateActionTypes';

export interface ILetterTemplatesState {
  isLoading: boolean;
  hasError: boolean;
  errorMessage: string;
  statusCode: number;
  templates: ILetterTemplate[];
}

export const templatesInitialState: ILetterTemplatesState = {
  templates: [],
  isLoading: false,
  hasError: false,
  errorMessage: null,
  statusCode: 0,
};

export function letterTemplatesReducer(
  prev: ILetterTemplatesState = templatesInitialState,
  action: TemplateActions
): ILetterTemplatesState {
  switch (action.type) {
    case TemplateActionTypes.REQUEST_TEMPLATES: {
      return {
        ...prev,
        isLoading: true,
        hasError: false,
        errorMessage: null,
      };
    }
    case TemplateActionTypes.RECEIVE_TEMPLATES: {
      return {
        ...prev,
        templates: action.templates,
        isLoading: false,
        hasError: false,
        errorMessage: null,
      };
    }
    case TemplateActionTypes.REQUEST_TEMPLATES_FAILED: {
      return {
        ...prev,
        templates: [],
        isLoading: false,
        hasError: true,
        errorMessage: action.errorMessage,
        statusCode: action.statusCode,
      };
    }
    default:
      return prev;
  }
}
